// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React from "react";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import ExamPaper from "../components/exam/ExamPaper";
import { routes } from "../config/constant";
import LoginLayout from "../layouts/LoginLayout";
import MainLayout from "../layouts/MainLayout";
import AwardedCertificates from "../pages/AwardedCertificates";
import Certifications from "../pages/Certifications";
import Exams from "../pages/Exams";
import LandingPage from "../pages/LandingPage";
import NotFound from "../pages/NotFound";
import { RootState, useAppSelector } from "../slices/store";
import PrivateRoute from "./PrivateRoute";
import { PublicRoute } from "./PublicRoute";
import AwardedCertificate from "../pages/AwardedCertificate";
import MaintenancePage from "../pages/Maintenance";

const AuthHandler: React.FC = () => {
  const auth = useAppSelector((state: RootState) => state.auth);
  const appMaintenanceStatus = useAppSelector((state: RootState) => state.app.response);

  const router = createBrowserRouter([
    {
      path: routes.base,
      element: (
        <PublicRoute>
          <LoginLayout />
        </PublicRoute>
      ),
      errorElement: <NotFound />,
    },
    {
      path: routes.certificate,
      element: <AwardedCertificates />,
      errorElement: <NotFound />,
    },
    {
      path: routes.certificates,
      element: <AwardedCertificates />,
      errorElement: <NotFound />,
    },
    {
      path: routes.sharedCertificate,
      element: <AwardedCertificate />,
      errorElement: <NotFound />,
    },
    {
      path: routes.home,
      element: (
        <PrivateRoute>
          {" "}
          <MainLayout />
        </PrivateRoute>
      ),
      errorElement: <NotFound />,
      children: [
        {
          index: true,
          element: (
            <PrivateRoute>
              {" "}
              <LandingPage />
            </PrivateRoute>
          ),
        },
        {
          path: routes.exams,
          element: (
            <PrivateRoute>
              <Exams />
            </PrivateRoute>
          ),
        },
        {
          path: routes.examPaper,
          element: (
            <PrivateRoute>
              <ExamPaper />
            </PrivateRoute>
          ),
        },
        {
          path: routes.certifications,
          element: (
            <PrivateRoute>
              <Certifications />
            </PrivateRoute>
          ),
        },
      ],
    },
    {
      path: routes.certificate,
      element: (
        <PublicRoute checkStatus={false}>
          <AwardedCertificates />
        </PublicRoute>
      ),
      errorElement: <NotFound />,
    },
  ]);

  return (
    <>
      {appMaintenanceStatus.isAppInMaintenanceState && (
        <RouterProvider
          router={createBrowserRouter([
            {
              path: "*",
              element: <MaintenancePage />,
              errorElement: <NotFound />,
            },
          ])}
        />
      )}
      {!appMaintenanceStatus.isAppInMaintenanceState && (auth.status === "success" || auth.status === "idle") && (
        <RouterProvider router={router} />
      )}
    </>
  );
};

export default AuthHandler;
